import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import paymentService from "@/services/api/payments";
import type { GetPaymentsParams, Payment } from "@/services/api/payments";

export interface PaymentState {
  payments: Payment[];
  totalPayments: number;
  isFetching: boolean;
  error: string | null;
}

const initialState: PaymentState = {
  payments: [],
  totalPayments: 0,
  isFetching: false,
  error: null,
};

export const getPayments = createAsyncThunk(
  "payment/getPayments",
  async (params: GetPaymentsParams | undefined) => paymentService.getPayments(params),
);

const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPayments.pending, (state) => {
        state.isFetching = true;
        state.error = null;
      })
      .addCase(getPayments.fulfilled, (state, action) => {
        state.isFetching = false;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const payload = action.payload as any;
        const rawResults = payload?.data?.results ?? payload?.results ?? (Array.isArray(payload?.data) ? payload.data : []);
        state.payments = Array.isArray(rawResults) ? rawResults : [];
        state.totalPayments = payload?.data?.totalRecord ?? payload?.totalRecord ?? state.payments.length;
      })
      .addCase(getPayments.rejected, (state, action) => {
        state.isFetching = false;
        state.payments = [];
        state.error = action.error.message ?? "Failed to load payments";
      });
  },
});

export default paymentSlice.reducer;
